import React, { useState, useEffect } from 'react';
    import DashboardShell from './components/DashboardShell';
    import moment from 'moment';
    import Modal from 'react-modal';
    
    const API_URL = process.env.REACT_APP_API_URL;
    
    const FirmLeadCenter = () => {
        const [intakeUsers, setIntakeUsers] = useState([]);
        const [loading, setLoading] = useState(true);
        const [selectedUser, setSelectedUser] = useState(null);
        const [modalIsOpen, setModalIsOpen] = useState(false);
        const token = localStorage.getItem('accessToken');
        function getDeviceType(uaString) {
            const ua = (uaString || '').toLowerCase();
          
            // 1) iPhone explicitly
            if (ua.includes('iphone')) {
              return 'iphone';
            }
          
            // 2) Android phone: Android *and* Mobile
            if (ua.includes('android') && ua.includes('mobile')) {
              return 'android';
            }
          
            // 3) Tablet:
            //    • iPad
            //    • Android without "Mobile"
            //    • Generic "Tablet"
            if (
              ua.includes('ipad') ||
              (ua.includes('android') && !ua.includes('mobile')) ||
              ua.includes('tablet')
            ) {
              return 'tablet';
            }
          
            // 4) Fallback to desktop
            return 'desktop';
          }
        useEffect(() => {
            const fetchIntakeUsers = async () => {
                try {
                    const response = await fetch(`${API_URL}/intake-users/`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        },
                    });
                    if (!response.ok) {
                        throw new Error('Failed to fetch intake users');
                    }
                    const data = await response.json();
    
                    setIntakeUsers(data)
                    console.log(data)
                    setLoading(false);
                } catch (error) {
                    console.error(error);
                    setLoading(false);
                }
            };
    
            fetchIntakeUsers();
        }, [token]);
    
        const openModal = (user) => {
            setSelectedUser(user);
            setModalIsOpen(true);
        };
    
        const closeModal = () => {
            setSelectedUser(null);
            setModalIsOpen(false);
        };
    
        return (
            <DashboardShell>
                <div className="px-4 sm:px-6 lg:px-8">
                    <div className="sm:flex sm:items-center sm:justify-between">
                        <h2 className="text-lg font-bold leading-6 text-gray-900">Lead Center</h2>
                    </div>
                    <div className="mt-8 flow-root">
                        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                <table className="min-w-full divide-y divide-gray-300">
                                    <thead>
                                        <tr>
                                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                                Name
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Updated At
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Visit Count
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Device
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                IP Location
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                IP Address
                                            </th>
                                            <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                                <span className="sr-only">Actions</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200">
                                        {intakeUsers.map((user) => (
                                            <tr key={user.id}>
                                                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                    {user.data ? `${user.data.firstName} ${user.data.lastName}` : 'N/A'}
                                                </td>
                                                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                    {user.data ? `${user.updated_at}` : 'N/A'}
                                                </td>
                                                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                    {user.data ? `${user.visit_count}` : 'N/A'}
                                                </td>
                                                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                    {user.data ? `${getDeviceType(user.user_agent)}` : 'N/A'}
                                                </td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                {user.ip_geo_data?.city && user.ip_geo_data?.region_iso_code
                                                    ? `${user.ip_geo_data.city}, ${user.ip_geo_data.region_iso_code}`
                                                    : 'N/A'}
                                                </td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                    {user.ip_address || 'N/A'}
                                                </td>
                                                <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                    <button
                                                        onClick={() => openModal(user)}
                                                        className="text-indigo-600 hover:text-indigo-900"
                                                    >
                                                        View Details
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
    
                <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    contentLabel="Intake User Details"
                    className="fixed inset-0 z-50 overflow-y-auto"
                    overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center"
                >
                    <div className="relative top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg shadow-xl p-6 w-full max-w-2xl">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-2xl font-bold text-gray-800">Intake User Details</h2>
                            <button
                                type="button"
                                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                                onClick={closeModal}
                            >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path>
                                </svg>
                            </button>
                        </div>
                        {selectedUser && (
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div>
                                    <p className="text-sm text-gray-500 mb-2">
                                        <span className="font-semibold text-gray-700">Name:</span> {selectedUser.data ? `${selectedUser.data.firstName} ${selectedUser.data.lastName}` : 'N/A'}
                                    </p>
                                    <p className="text-sm text-gray-500 mb-2">
                                        <span className="font-semibold text-gray-700">Device:</span> {selectedUser.user_agent ? `${selectedUser.user_agent} ${selectedUser.user_agent}` : 'N/A'}
                                    </p>
                                    <p className="text-sm text-gray-500 mb-2">
                                        <span className="font-semibold text-gray-700">Email:</span> {selectedUser.data ? selectedUser.data.email : 'N/A'}
                                    </p>
                                    <p className="text-sm text-gray-500 mb-2">
                                        <span className="font-semibold text-gray-700">Phone:</span> {selectedUser.data ? selectedUser.data.phone : 'N/A'}
                                    </p>
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500 mb-2">
                                        <span className="font-semibold text-gray-700">Date of Birth:</span> {selectedUser.data ? selectedUser.data.dob : 'N/A'}
                                    </p>
                                    <p className="text-sm text-gray-500 mb-2">
                                        <span className="font-semibold text-gray-700">Marital Status:</span> {selectedUser.data ? selectedUser.data.maritalStatus : 'N/A'}
                                    </p>
                                    <p className="text-sm text-gray-500 mb-2">
                                        <span className="font-semibold text-gray-700">Address:</span> {selectedUser.data ? `${selectedUser.data.street}, ${selectedUser.data.city}, ${selectedUser.data.state} ${selectedUser.data.zip}` : 'N/A'}
                                    </p>
                                </div>
                                {/* Display other details here, format as needed */}
                            </div>
                        )}
                        <div className="flex justify-end mt-4 space-x-2">
                            <button
                                type="button"
                                className="text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-500 dark:hover:bg-blue-600 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                onClick={closeModal}
                            >
                                Close
                            </button>
                            {/* Add more buttons as needed */}
                        </div>
                    </div>
                </Modal>
            </DashboardShell>
        );
    };
    
    export default FirmLeadCenter;